import JSX from "../../../helpers/react.js";
import {ServerApi} from "../../../api.js";
import RefObject = JSX.RefObject;
import {handleFetchError, importALL} from "../../../helpers/functions.js";
import {LoadingSpinner} from "../../elements/index.js";

function StatisticsPeriods({onChange}: { onChange: (stat: string) => any }) {
    return (
        <div className="periods">
            Период:
            <div className="sub-menu-inner-container bordered-overflow inline">
                <span className="materiable default-button active sort-comments-btn bordered-overflow"
                      onClick={change('day')}>день</span>
                <span className="materiable default-button sort-comments-btn bordered-overflow"
                      onClick={change('7d')}>неделя</span>
                <span className="materiable default-button sort-comments-btn bordered-overflow"
                      onClick={change('30d')}>месяц</span>
                <span className="materiable default-button sort-comments-btn bordered-overflow"
                      onClick={change('1season')}>3 месяца</span>
                <span className="materiable default-button sort-comments-btn bordered-overflow"
                      onClick={change('1y')}>год</span>
            </div>
        </div>
    );

    function change(period: string) {
        return function (this: HTMLElement) {
            this.parentElement!.querySelector('.active')!.classList.remove('active');
            this.classList.add('active');
            onChange(period);
        }
    }
}

export function StatisticsPage({appId}: { appId: number }) {
    const contentElement: RefObject<HTMLDivElement> = {};
    importALL(
        'https://cdn.jsdelivr.net/npm/chart.js@v4.3.3',
    ).then(
        () => importALL('https://cdn.jsdelivr.net/npm/chartjs-adapter-date-fns@v3.0.0',
            'https://cdn.jsdelivr.net/npm/chartjs-adapter-date-fns/dist/chartjs-adapter-date-fns.bundle.min.js'
        )
    ).then(
        () => loadGraph(contentElement, appId, "day")
    );
    return (
        <div className="statistics">
            <h1 style={{paddingTop: "10px"}}>Статистика по запросам</h1>
            <StatisticsPeriods onChange={stat => loadGraph(contentElement, appId, stat)}/>
            <div className="content" ref={contentElement}/>
        </div>
    )
}


async function loadGraph(to: RefObject<HTMLDivElement>, appId: number, period: string) {
    try {
        to.value!.innerText = '';
        to.value!.appendChild(<LoadingSpinner/>)
        const data = await ServerApi.apps.getStatistics(appId, period);
        to.value!.innerText = '';
        to.value!.appendChild(<OneGraph data={data.data} start={new Date(data.start * 1000)}/> as Node);
    } catch (e) {
        handleFetchError(e);
        to.value!.innerText = '';
        to.value!.appendChild(<Error retry={() => loadGraph(to, appId, period)}/> as Node);
    }
}

function Error({retry}: { retry: () => any }) {
    return (
        <div className="center">
            Произошла неизвестная ошибка. <br/>
            <button className="main-button bordered" onClick={retry}>Попробовать ещё раз</button>
        </div>
    )
}

function parsePeriodCount(start: number, end: number) {
    if (end - start <= 3600 * 24 + 10) return 24 * 60;
    if (end - start <= 3600 * 24 * 7 + 10) return 7 * 24 * 60;
    return Math.round((end - start) / 3600 / 24);
}

function OneGraph({data: dataOld, start}: { data: { [_: number]: number }, start: Date }) {
    const getVar = (v: string) => getComputedStyle(document.documentElement).getPropertyValue(v);
    const gridColor = getVar('--main-text'),
        nodeColor = getVar('--border-first');


    const startUnix = Math.floor(+start / 1000), endUnix = Math.floor(+new Date / 1000);
    let period = parsePeriodCount(startUnix, endUnix);
    const data = optimizeData(dataOld, startUnix, endUnix, period);
    const dataCanvas: RefObject<HTMLCanvasElement> = {};
    const $el = (
        <div id="statistics">
            <canvas ref={dataCanvas}/>
        </div>
    );
    const ctx = dataCanvas.value!.getContext('2d');
    const dataArray = Array.from(data).map(
        (value, index) => ({
            x: (startUnix + (endUnix - startUnix) * ((index + 1) / period)) * 1000,
            y: value
        })
    );
    //@ts-ignore
    new Chart(ctx, {
        type: 'line',
        data: {
            datasets: [{
                label: `Статистика по использованию API (всего ${(summary(data)).toLocaleString('ru-RU', {minimumFractionDigits: 0})})`,
                data: dataArray,
                borderColor: nodeColor,
                pointRadius: 1,
                pointHoverRadius: 3
            }]
        },
        options: {
            scales: {
                x: {
                    type: 'time',
                    min: +startUnix * 1000,
                    max: +endUnix * 1000,
                    time: {
                        parser: 'HH:MM:SS',
                        // round: 'day'
                        tooltipFormat: 'yyyy-MM-dd HH:mm',
                        displayFormats: {
                            millisecond: 'HH:mm:ss.SSS',
                            second: 'HH:mm:ss',
                            minute: 'HH:mm',
                            hour: 'HH'
                        }
                    },
                    grid: {
                        color: gridColor
                    },
                },
                y: {
                    type: 'linear',
                    min: 0,
                    max: Math.max(...data) * 1.5,
                    grid: {
                        color: gridColor
                    },
                }
            }
        }
    });
    return $el;

}

function optimizeData(objectData: { [key: string]: number }, min: number, max: number, maxLength = 100) {
    const ans = new Uint32Array(maxLength);
    const keys = Object.keys(objectData).sort((a, b) => -(-a + (+b))).map(e => +e);
    let currentIndex = 0;
    for (let element of keys) {
        if (element < min) continue;
        if (element > max) break;
        const delta = element - min, range = max - min;
        currentIndex = ~~((delta / range) * maxLength);
        ans[currentIndex] += objectData[element];
    }
    return ans;

    // let length = Math.round(keys.length / maxLength);
    // if (length === 0) length = 1;
    // const ans: { [k: number]: number } = {};
    // for (let i = ~~(length / 2); i <= keys.length; i += length) {
    //     const sum = keys.slice(Math.floor(i - length / 2), Math.ceil(i + length / 2)).map(e => objectData[e]);
    //     ans[keys[i]] = summary(sum)
    // }
    // return ans;
}

function summary(a: Iterable<number>) {
    let ans = 0;
    for (const i of a) ans += +i;
    return ans;
}

